import React from 'react';
import { Image, VStack } from '@chakra-ui/react';
import { Outlet } from 'react-router';
import Logo from '../assets/LogoVector.svg';

const AuthLayout = () => {
    return (
        <VStack h='100vh' justifyContent='center' gap={16}>
            <Image src={Logo} width={200}/>
            <Outlet />
        </VStack>
    )
}

export default AuthLayout;